import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import ApiBase from '@/api/base';
import {
  UserProfileApi,
  UserProfileApiPutCurrentUserRequest,
  UserProfileApiPostCurrentUserAvatarImageRequest,
  GetCurrentUser200Response,
} from '@/api/openapi';

export class CurrentUserApiService extends ApiService {
  api = new UserProfileApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getCurrentUser({
    options,
    errorHandlers,
  }: ApiArguments<undefined>): Promise<AxiosResponse<GetCurrentUser200Response>> {
    return this.checkResponse<GetCurrentUser200Response>(
      this.api.getCurrentUser(options),
      errorHandlers,
    );
  }

  async updateCurrentUser({
    request,
    options,
    errorHandlers,
  }: ApiArguments<UserProfileApiPutCurrentUserRequest>): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(
      this.api.putCurrentUser(request, options),
      errorHandlers,
    );
  }

  async updateCurrentUserAvatarImage({
    request,
    options,
    errorHandlers,
  }: ApiArguments<UserProfileApiPostCurrentUserAvatarImageRequest>): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(
      this.api.postCurrentUserAvatarImage(request, options),
      errorHandlers,
    );
  }
}

export default {
  getCurrentUser (args) {
    return ApiBase.get(`/user/me`, args);
  },
};
